import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import {
  StepDiscountSettingsComponent,
  StepBuilderComponent,
  StepButtonComponent,
  StepDiscountComponent,
  StepEmulatorComponent,
  StepExchangeableProductsComponent,
  StepFormComponent,
  StepMediaComponent,
  StepSurveyOptionsComponent,
  StepResponseScreenComponent,
  StepTextualComponent,
  OfferPopupComponent,
  StepPopupComponent,
  StepTimeDelayComponent,
  StepFixedImagesComponent,
  StepTimeOptionsComponent,
  StepActionsComponent,
  TemplatePopupComponent,
  StepTemplatesComponent,
  StepProductImagesComponent,
  OfferPreviewComponent,
  StepTypePopupComponent,
  StepSubtypePopupComponent,
  ExchangeableTypeConfirmPopup,
  StepCancellationComponent,
  StepAdvancedSettingsComponent,
  StepUpsaleProductComponent,
  StepLayoutComponent,
} from '.';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { SharedModule } from '../_shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatExpansionModule, MatTreeModule } from '@angular/material';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    StepDiscountSettingsComponent,
    StepDiscountComponent,
    StepExchangeableProductsComponent,
    ExchangeableTypeConfirmPopup,
    StepButtonComponent,
    StepMediaComponent,
    StepFixedImagesComponent,
    StepSurveyOptionsComponent,
    StepTimeOptionsComponent,
    StepResponseScreenComponent,
    StepTextualComponent,
    StepActionsComponent,
    StepTimeDelayComponent,
    StepBuilderComponent,
    StepFormComponent,
    StepEmulatorComponent,
    OfferPopupComponent,
    StepPopupComponent,
    TemplatePopupComponent,
    StepTypePopupComponent,
    StepSubtypePopupComponent,
    StepTemplatesComponent,
    StepProductImagesComponent,
    OfferPreviewComponent,
    StepCancellationComponent,
    StepAdvancedSettingsComponent,
    StepUpsaleProductComponent,
    StepLayoutComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    SharedModule,
    NgbModule,
    MatExpansionModule,
    MatTreeModule,
    DragDropModule,
    NgxSmartModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [
    StepDiscountSettingsComponent,
    StepDiscountComponent,
    StepExchangeableProductsComponent,
    ExchangeableTypeConfirmPopup,
    StepButtonComponent,
    StepMediaComponent,
    StepFixedImagesComponent,
    StepSurveyOptionsComponent,
    StepTimeOptionsComponent,
    StepResponseScreenComponent,
    StepTextualComponent,
    StepActionsComponent,
    StepTimeDelayComponent,
    StepBuilderComponent,
    StepFormComponent,
    StepEmulatorComponent,
    OfferPopupComponent,
    StepPopupComponent,
    TemplatePopupComponent,
    StepTypePopupComponent,
    StepSubtypePopupComponent,
    StepTemplatesComponent,
    StepProductImagesComponent,
    OfferPreviewComponent,
    StepCancellationComponent,
    StepAdvancedSettingsComponent,
    StepUpsaleProductComponent,
    StepLayoutComponent,
  ],
  providers: [],
  bootstrap: [],
})
export class StepsLibraryModule {}
